// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__KJB6j","spinner1":"Spinner_spinner1__uB6V4"};